export const flowReports = {
  id: 'flow',
  name: 'Flows',
  description: '',
  visibility: 'private',
  subject_type: 'flow',
  layout: {
    data: [
      {
        h: 26,
        w: 12,
        x: 0,
        y: 0,
        key: '4832',
        maxH: 32,
        maxW: 12,
        minH: 21,
        minW: 3,
      },
      {
        h: 25,
        w: 12,
        x: 0,
        y: 44,
        key: '4833',
        maxH: 32,
        maxW: 12,
        minH: 21,
        minW: 3,
      },
      {
        h: 18,
        w: 12,
        x: 0,
        y: 26,
        key: '4834',
        maxH: 100,
        maxW: 12,
        minH: 8,
        minW: 8,
      },
      {
        h: 16,
        w: 12,
        x: 0,
        y: 69,
        key: '4835',
        maxH: 100,
        maxW: 12,
        minH: 8,
        minW: 8,
      },
    ],
  },
  tiles: [
    {
      id: 4832,
      subject_type: 'flow_health',
      metadata: {
        id: 'flow_candidate_touchpoint_chart',
        tileKey: 'flow_candidate_touchpoint_chart',
        apiParam: 'flow_health',
        headerKeys: [],
        componentType: 'chart',
      },
      query: null,
    },
    {
      id: 4834,
      subject_type: 'flow_health',
      metadata: {
        id: 'flow_health',
        tileKey: 'flow_health',
        apiParam: 'flow_health',
        headerKeys: ['contacted', 'opened', 'replied', 'interested'],
        componentType: 'table',
      },
      query: null,
    },
    {
      id: 4833,
      subject_type: 'flow_health',
      metadata: {
        id: 'flow_user_activity_chart',
        tileKey: 'flow_user_activity_chart',
        apiParam: 'flow_user_activity',
        headerKeys: [],
        componentType: 'chart',
      },
      query: null,
    },
    {
      id: 4836,
      subject_type: 'flow_user_activity',
      metadata: {
        id: 'flow_user_activity',
        tileKey: 'flow_user_activity',
        apiParam: 'flow_user_activity',
        headerKeys: ['contacted', 'opened', 'replied', 'interested'],
        componentType: 'table',
      },
      query: null,
    },
  ],
  user: {
    id: null,
  },
};
